import { render, staticRenderFns } from "./CreateTasks.vue?vue&type=template&id=07170ae8&"
import script from "./CreateTasks.vue?vue&type=script&lang=js&"
export * from "./CreateTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports